<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const grammarBlocks = [
  { title: "Stories", to: "/11th/english/grammar/stories/", detail: "Story writing ke liye common prompts aur basic madad." },
  { title: "Letters", to: "/11th/english/grammar/letters/", detail: "Letter prompts, format aur sample letter." },
  { title: "Applications", to: "/11th/english/grammar/applications/", detail: "Application format, common prompts aur sample application." },
  { title: "Story Writing", to: "/11th/english/grammar/story-writing/", detail: "Story framework, moral lines aur mini model story." },
  { title: "Pair of Words", to: "/11th/english/grammar/pair-of-words/", detail: "Practice set, sentence usage aur MCQ explanation." },
  { title: "Punctuation", to: "/11th/english/grammar/punctuation/", detail: "Core rules, correction examples aur common mistakes." },
  { title: "Translation", to: "/11th/english/grammar/translation/", detail: "Translation strategy, mini examples aur common issues." },
  { title: "Essay", to: "/11th/english/grammar/essay/", detail: "Essay framework, topics, intro example aur common mistakes." },
  { title: "Grammar with MCQs", to: "/11th/english/grammar-with-mcqs/", detail: "Grammar ke important MCQs aur practice." },
];

const recommendedFlow = [
  "Pair of Words aur Punctuation se shuru karein.",
  "Letters, Applications aur Story Writing par phir kaam karein.",
  "Translation aur Essay ko akhir me revise karein.",
  "Grammar with MCQs se practice dobara kar lein.",
];

const prepGroups = [
  { title: "Objective Prep", items: "Pair of Words, Punctuation, Grammar with MCQs" },
  { title: "Writing Prep", items: "Letters, Applications, Story Writing, Stories" },
  { title: "Composition Support", items: "Translation, Essay" },
];

const faqs = [
  {
    question: "What is included in this grammar page?",
    answer: "Is page par pair of words, punctuation, letters, applications, stories, translation, essay aur grammar with MCQs milte hain.",
  },
  {
    question: "Should I start grammar prep with writing or objective sections?",
    answer: "Behtar yeh hai ke pehle pair of words aur punctuation se start karein, phir writing topics par jayein.",
  },
  {
    question: "Can I open grammar topics directly from here?",
    answer: "Haan, har topic yahan se seedha khul jata hai.",
  },
];

usePageSeo({
  title: "11th Class English Grammar and Composition | Letters, Applications, Pair of Words",
  description: "11th class English grammar and composition ke liye pair of words, punctuation, letters, applications, story writing, translation aur essay ka page.",
  keywords: "11th class english grammar, class 11 english grammar, english composition 11th class, pair of words, letters, applications, punctuation",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: grammarBlocks.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Grammar", item: "/11th/english/grammar/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="11th Class English"
      title="11th Class English Grammar & Composition"
      description="Yahan se aap 11th class English grammar aur composition ke tamam important topics khol sakte hain."
    />

    <EnglishSection
      title="Grammar Topics"
      description="Jis topic ki tayari karni ho, us par click karein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in grammarBlocks"
          :key="item.to"
          :title="item.title"
          :description="item.detail"
          :to="item.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Recommended Order"
      description="Agar samajh nahi aa raha kahan se start karein, to ye order follow karein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in recommendedFlow"
          :key="item"
          title="Suggestion"
          :description="item"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Prep Groups"
      description="Ye grouping batati hai ke kaunsa topic objective, writing ya composition me zyada kaam aata hai."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in prepGroups"
          :key="item.title"
          :title="item.title"
          :description="item.items"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="Grammar ke bare me aam sawalon ke jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
